export default ({ hours, minutes, seconds, ampm }, context) => {
    if (ampm === "pm" && hours < 12) {
        hours += 12
    }
	return {
		type: "date",
		value: { hours, minutes, seconds },
		primitive: true,
	};
};